import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import CtflAsset from '@components/ctfl-asset'
import Embed from '@components/embed'
import { JsonLd } from '@components/atoms'

import { ArticleHeroRoot, useArchiveImageStyles } from './article-hero.styles'

const ArchiveImage = ({src, alt}) => {
  const styles = useArchiveImageStyles()

  return <img src={src} alt={alt} className={styles.root} />
}

const ArticleHero = ({
  image,
  video,
  heroCaption,
  heroSource,
  archiveImage,
  heroVideoEmbed,
  headline,
}) => {
  const defaultCaption = video ? video.description : image && image.description
  return (
    <ArticleHeroRoot maxwidth={(image && (!video && !heroVideoEmbed)) ? image.width : null}>
      <Box mx={[-2, -3, -4, 0]}>
        {video && <CtflAsset {...video} poster={image && image.url} width={video.width || 1216} height={video.height || 684} hideDescription />}
        {heroVideoEmbed && <Embed {...heroVideoEmbed} />}
        {(image && (!video && !heroVideoEmbed)) && <CtflAsset {...image} hideDescription />}
        {archiveImage && !heroVideoEmbed && <ArchiveImage src={archiveImage} alt={heroCaption || defaultCaption || headline} />}
      </Box>
      <Box mt={1} mb={[3, 4, 6]} component="p" fontSize={12}>
        <Box component="span" pr={1}>{heroCaption || defaultCaption}</Box>
        {heroSource && <Box component="span" color="grey.dark">{heroSource}</Box>}
      </Box>
      {video
        && (
          <JsonLd {...{
            '@type': 'VideoObject',
            caption: video.description,
            transcript: video.description,
            publisher: {
              '@type': 'SportsOrganization',
              sport: 'Golf',
              foundingDate: '2019-01-10',
              foundingLocation: {
                '@type': 'Place',
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: 'Palm Beach Gardens',
                  addressRegion: 'FL',
                  postalCode: '33418',
                  streetAddress: '100 Avenue of the Champions',
                },
              },
            },
          }
          }
          />
        )}
    </ArticleHeroRoot>
  )
}

ArticleHero.propTypes = {
  image: PropTypes.shape(),
  video: PropTypes.shape(),
  heroSource: PropTypes.string,
  heroCaption: PropTypes.string,
  archiveImage: PropTypes.string,
  headline: PropTypes.string,
}

ArticleHero.defaultProps = {}

export default ArticleHero
